module.exports = __webpack_public_path__ + "img/jisushenhe.b10fe02a.png";